import React, { useState } from "react";
import Chart from "react-apexcharts";

export default function Warehousesaleratio() {
  const [Saleratio, SetSaleratio] = useState({
    options: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      colors: ["#1F78B4"],

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        forceNiceScale: false,
        max: 100,
        labels: {
          formatter: (value) => value.toFixed(0) + "%",
        },
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 4,
      },
      states: {
        normal: {
          filter: {
            type: "none",
            value: 0,
          },
        },
        hover: {
          filter: {
            type: "lighten",
            value: 0.15,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "darken",
            value: 0.35,
          },
        },
      },
    },

    series: [
      {
        name: "Inventory to Sale Ratio",
        data: [83, 80, 92, 87, 95, 90, 97, 87, 84, 78, 87, 96],
      },
    ],
  });
  return (
    <div>
      <div class="mt-8">
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 pt-2">
            <h3 className="text-lg font-bold mx-3"> Inventory to Sale Ratio</h3>
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2 ">
                  {" "}
                  W
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3  border-1 rounded-3xl ml-10 float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline rounded-full pl-10 focus:outline-1 focus:outline-slate-200 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div className="flex flex-wrap pb-2">
            <div className="w-full ml-4 mt-24 mb-20 bg-blue-50 align-middle shadow-md shadow-slate-400 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6  mx-1 rounded-xl mr-6">
              <div className="text-center  mt-4">
                <div className="text-center">
                  <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                    {" "}
                    <svg
                      className="relative top-[6px] left-[6px]"
                      width="46"
                      height="46"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21 6L15.7071 11.2929C15.3166 11.6834 14.6834 11.6834 14.2929 11.2929L12.7071 9.70711C12.3166 9.31658 11.6834 9.31658 11.2929 9.70711L7 14"
                        stroke="#1F78B4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M3 3V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H21"
                        stroke="#1F78B4"
                        stroke-linecap="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <h1 className="text-4xl text-center font-bold mt-4">25 USD</h1>
              <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
                Inventory to Sales Ratio
              </h1>
              <p className="text-lime-400 text-center mb-1 ">
                <span>
                  <span className="inline-block">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                        fill="#26F32E"
                      />
                      <path
                        d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                        fill="#26F32E"
                      />
                    </svg>
                  </span>
                </span>
                <span className="ml-1 font-medium">0.8%</span>
              </p>
              <div className="text-center flex justify-center ml-auto mt-1 pt-4 mb-4">
                <div className="">
                  <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                    {" "}
                    Y
                  </button>
                </div>
                <div className="">
                  <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                    {" "}
                    M
                  </button>
                </div>

                <div className="">
                  <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                    {" "}
                    W
                  </button>
                </div>
              </div>
            </div>
            <div className="flex-2 md:overflow-x-auto overflow-x-auto  float-right ml-auto mr-4 mt-1">
              <div className="relative overflow-x-auto  sm:rounded-lg">
                <Chart
                  options={Saleratio.options}
                  series={Saleratio.series}
                  type="line"
                  height="380"
                  width="95%"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
